import { cva } from '@/styled-system/css';

export const datePickerTriggerRecipe = cva({
  base: {},
  variants: {
    size: {
      sm: {
        paddingInline: 'DatePicker.Trigger.padding.sm.horz',
        borderTopRightRadius: 'DatePicker.Trigger.sm.topRight',
        borderBottomRightRadius: 'DatePicker.Trigger.sm.bottomRight',
        borderTopLeftRadius: 'DatePicker.Trigger.sm.topLeft',
        borderBottomLeftRadius: 'DatePicker.Trigger.sm.bottomLeft',
      },
      md: {
        paddingInline: 'DatePicker.Trigger.padding.md.horz',
        borderTopRightRadius: 'DatePicker.Trigger.md.topRight',
        borderBottomRightRadius: 'DatePicker.Trigger.md.bottomRight',
        borderTopLeftRadius: 'DatePicker.Trigger.md.topLeft',
        borderBottomLeftRadius: 'DatePicker.Trigger.md.bottomLeft',
      },
      lg: {
        paddingInline: 'DatePicker.Trigger.padding.lg.horz',
        borderTopRightRadius: 'DatePicker.Trigger.lg.topRight',
        borderBottomRightRadius: 'DatePicker.Trigger.lg.bottomRight',
        borderTopLeftRadius: 'DatePicker.Trigger.lg.topLeft',
        borderBottomLeftRadius: 'DatePicker.Trigger.lg.bottomLeft',
      },
    },
    disabled: {
      true: {},
      false: {
        boxShadow: {
          transition: {
            _motionReduce: 'none',
            _motionSafe: 'box-shadow 200ms ease',
          },
          _focusVisible:
            'inset 0 0 0 {borderWidths.DatePicker.Trigger.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
    error: {
      true: {},
      false: {},
    },
    readOnly: {
      true: {
        display: 'none',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      error: false,
      css: {
        boxShadowColor: {
          _focusVisible: 'DatePicker.Trigger.border.active',
        },
      },
    },
    {
      disabled: false,
      error: true,
      css: {
        boxShadowColor: {
          _focusVisible: 'DatePicker.Trigger.border.error',
        },
      },
    },
  ],
});
